//Team Actions
export const GAME_RESULT = 'game_result';
export const GAME_RESULT_TIE = 'game_result_tie';
export const UPDATE_SOV = 'update_SOV';
export const RESET_LEAGUE = 'reset_league';

// Sort Standings Actions
// export const SORT_DIVISION = 'sort_division';
// export const SORT_CONFRENCE = 'sort_confrence';

// export const UPDATE_SCHEDULE = 'update_schedule';

//Schedule Actions
export const GET_GAMEGRID = 'get_gamegrid';
export const GET_GAMELIST = 'get_gamelist';
export const GET_SCHEDULE = 'get_schedule';

//User Data actions
export const UPDATE_UGAMELIST = 'update_ugamelist';
export const UPDATE_GAMEPICKS = 'update_gamepicks';
export const ADD_BYE = 'add_bye';
export const NAME = 'name';
export const LOAD_SAVE = 'load_save';
export const SAVE_SAVE = 'save_save';
export const SEASON_CHANGE = 'season_change';

//Settings Actions
export const UPDATE_PROGRESSBAR = 'update_progressbar';
export const CHANGE_PICK_TYPE = 'change_pick_type';
export const UPDATE_STANDINGS_DETAILS = 'update_standings_detail';
export const UPDATE_PLAYOFF_PIC = 'update_playoff_pic';
export const CHANGE_TEAM_PICK = 'change_team_pick';
export const SHOW_ABOUT = 'show_about';
export const SHOW_INSTRUCTIONS = 'show_instructions';
export const SHOW_LOGIN = "show_login";
export const SET_SEASON = "set_season";
export const STANDINGS_PLACE = "standings_place";
export const LOGOS = "logo_display";
export const PLAYOFFS = "playoffs";
export const PLAYOFFS_NOW = "playoffs_now";
